<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
  <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
    (click)="modal.close('ferme')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form autocomplete="off" [formGroup]="form" (ngSubmit)="onConfirme()">
  <div class="modal-body">
    <div class="col-md-12">
      <aw-wizard #wizard class="arc-wizard">
        <!-- STEP 1 DU FORMULAIRE -->
        <aw-wizard-step stepTitle="{{ !edit ? 'Promotion' : 'Maison'}}">
          <div class="row">
            <span class="badge badge-secondary my-2 f-14 width">
              Partie reservée au programme
            </span>
          </div>
          <div class="form-group row">
            <div class="col-md-3">
              <label for="promotion">
                {{ (promotion?.parent != null && edit)? 'Sous Programme': 'Programme'}} <span class="asterix"></span>
              </label>
              <ng-select [readonly]="edit" formControlName="promotion" class="form-control custom-ng-select"
                [items]="promotions" bindLabel="libelle" bindValue="uuid" class="form-control" id="promotion"
                (change)="onChangePromotion($event)">
              </ng-select>
            </div>
            <div *ngIf="edit == false &&  f.promotion.value && sousPromotions.length>0" class="col-md-3">
              <label for="type">
                Sous Promotion <span class="asterix"></span>
              </label>
              <ng-select [readonly]="edit" formControlName="sousPromotion" class="form-control custom-ng-select"
                [items]="sousPromotions" bindLabel="libelle" bindValue="uuid" class="form-control" id="promotion"
                (change)="onChangeSousPromotion($event)">
              </ng-select>
            </div>
            <div class="col-md-3">
              <label for="numero">Situé </label>
              <input type="text" [value]="promotion?.localisation" class="form-control font-weight-bold p-2" placeholder="Situé" readonly>
            </div>
            <div class="col-md-3">
              <label for="numero">Superficie (m²)</label>
              <input type="text" [value]="promotion?.superficie" class="form-control font-weight-bold p-2" placeholder="Superficie (m²)" readonly>
            </div>
            <div class="col-md-3">
              <label for="numero">Nombre de maison </label>
              <input type="text" [value]="promotion?.nbrMaison" class="form-control font-weight-bold p-2" placeholder="Nombre de maison" readonly>
            </div>
          </div>

          <!-- Informations sur la maison -->
          <div class="row">
            <span class="badge badge-secondary my-2 f-14 width">
              Informations sur la maison
            </span>
          </div>  
          <div class="fom-group row">
            <div class="col-md-3">
              <label for="type">Type de maison <span class="asterix">*</span></label>
              <app-entity-finder [class]="'HomeType'" [groups]="['homeType']" [required]="true"
              [selected]="typeSelected" (uuid)="setHomeTypeUuid($event)">
              </app-entity-finder>
            </div>
            <div class="col-md-3" *ngIf="edit">
              <label for="lot">Lot N° </label>
              <input id="lot" formControlName="lot" class="form-control" [ngClass]="{
                'is-invalid': submit && f.lot.errors,
                'is-valid': submit && f.lot.valid}"
                type="text" placeholder="Lot N°">
            </div>
            <div class="col-md-3">
              <label for="ilot">Ilot N° <span class="asterix">*</span></label>
              <input (ngModelChange)="onChangeMaison()" id="ilot" formControlName="ilot" class="form-control" [ngClass]="{
                'is-invalid': submit && f.ilot.errors,
                'is-valid': submit && f.ilot.valid}"
                type="number" placeholder="Ilot N°">
              <div class="invalid-feedback" *ngIf="submit && f.ilot.errors">
                <div *ngIf="f.ilot.errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <label for="label">Libellé</label>
              <input id="label" formControlName="label" class="form-control" [ngClass]="{
                'is-invalid': submit && f.label.errors,
                'is-valid': submit && f.label.valid}"
                type="text" placeholder="Libellé">
              <div class="invalid-feedback" *ngIf="submit && f.label.errors">
                <div *ngIf="f.label.errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <label for="montant">Montant <span class="asterix">*</span></label>
              <input (ngModelChange)="onChangeMaison()" step="10000" class="form-control" id="montant" formControlName="montant" [ngClass]="{
                'is-invalid': submit && f.montant.errors,
                'is-valid': submit && f.montant.valid}"
                type="number" placeholder="Montant">
              <div class="invalid-feedback" *ngIf="submit && f.montant.errors">
                <div *ngIf="f.montant.errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <label for="baseActualisation">Base actualisation <span class="asterix">*</span></label>
              <input (ngModelChange)="onChangeMaison()" step="10000" class="form-control" id="baseActualisation" formControlName="baseActualisation" [ngClass]="{
                'is-invalid': submit && f.baseActualisation.errors,
                'is-valid': submit && f.baseActualisation.valid}"
                type="number" placeholder="Base actualisation">
              <div class="invalid-feedback" *ngIf="submit && f.baseActualisation.errors">
                <div *ngIf="f.baseActualisation.errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <label for="superficie">Superficie</label>
              <input (ngModelChange)="onChangeMaison()" step="100" class="form-control" id="superficie" formControlName="superficie" [ngClass]="{
                'is-invalid': submit && f.superficie.errors,
                'is-valid': submit && f.superficie.valid}"
                type="number" placeholder="Superficie">
              <div class="invalid-feedback" *ngIf="submit && f.superficie.errors">
                <div *ngIf="f.superficie.errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-3" *ngIf="!edit">
              <label for="nbrMaison">Nombre de maison <span class="asterix">*</span></label>
              <input (ngModelChange)="onChangeMaison()" formControlName="nbrMaison" type="number" class="form-control"
                [ngClass]="{
                  'is-invalid': submit && f.nbrMaison.errors,
                  'is-valid': submit && f.nbrMaison.valid
                }" placeholder="Nombre de maison">
              <div class="invalid-feedback" *ngIf="submit && f.nbrMaison.errors">
                <div *ngIf="f.nbrMaison.errors.required">{{required.novide}}</div>
                <div *ngIf="f.nbrMaison.errors.pattern">{{required.nolettre}}</div>
              </div>
            </div>
            <div class="col-md-3">
                <label for="titrefoncier">Numéro Titre Foncier</label>
                <input type="text" formControlName="titrefoncier" class="form-control" id="titrefoncier"
                placeholder="Titre foncier n°">
            </div>
            <div class="col-md-3">
                <label for="tolerance">Tolérance (%)<span class="asterix">*</span></label>
                <input type="number" formControlName="tolerance" class="form-control" id="tolerance" placeholder="Tolerance %">
            </div>
          </div>

          <!-- Configuration de la numérotation -->
          <div class="row" *ngIf="!edit && f.nbrMaison.value > 0">
            <span class="badge badge-info my-2 f-14 width">
              <i class="fas fa-cog me-2"></i>Configuration de la numérotation des lots
            </span>
          </div>

          <div class="card mb-3" *ngIf="!edit && f.nbrMaison.value > 0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <label for="radicalCode">
                    Radical du code (optionnel)
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Préfixe qui sera ajouté devant chaque numéro de lot. Ex: LOT, VILLA, etc.'"></i>
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="radicalCode"
                    [ngModelOptions]="{standalone: true}" id="radicalCode" placeholder="Ex: LOT, VILLA..."
                    (blur)="validateRadicalCode(radicalCode) || (radicalCode = '')">
                  <small class="text-muted">Laissez vide pour une numérotation simple</small>
                </div>
                
                <div class="col-md-2">
                  <label for="startNumber">
                    Numéro de départ <span class="asterix">*</span>
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Numéro à partir duquel commencer le décompte'"></i>
                  </label>
                  <input type="number" min="1" class="form-control" [(ngModel)]="startNumber"
                    [ngModelOptions]="{standalone: true}" id="startNumber" placeholder="Ex: 1, 100...">
                </div>
                
                <div class="col-md-2" *ngIf="!radicalCode || radicalCode.trim() === ''">
                  <label for="defaultIlot">
                    Ilot par défaut <span class="asterix">*</span>
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Numéro d\'ilot utilisé quand aucun radical n\'est défini'"></i>
                  </label>
                  <input type="number" min="1" class="form-control" [(ngModel)]="defaultIlot"
                    [ngModelOptions]="{standalone: true}" id="defaultIlot" placeholder="Ex: 1">
                </div>
                
                <div class="col-md-3">
                  <label for="numberingMode">
                    Mode de numérotation
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Choisissez comment numéroter les nouveaux lots'"></i>
                  </label>
                  <select class="form-control" [(ngModel)]="numberingMode" [ngModelOptions]="{standalone: true}">
                    <option value="continue">Continuer la série existante</option>
                    <option value="restart">Redémarrer avec le n° de départ</option>
                  </select>
                </div>
                
                <div class="col-md-2">
                  <label>&nbsp;</label>
                  <button type="button" class="btn btn-info form-control" (click)="regenerateAllLotNumbers()"
                    *ngIf="maison.length > 0">
                    <i class="fas fa-sync-alt"></i> Appliquer
                  </button>
                </div>
              </div>

              <!-- Aperçu du format -->
              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="alert alert-light">
                    <strong><i class="fas fa-eye me-2"></i>Aperçu du format :</strong>
                    <code>{{getPreviewLotFormat()}}</code>
                    <br>
                    <small class="text-muted">
                      <strong>Ilot :</strong>
                      <span *ngIf="radicalCode && radicalCode.trim() !== ''">
                        Sera égal au numéro du lot
                      </span>
                      <span *ngIf="!radicalCode || radicalCode.trim() === ''">
                        Sera fixé à {{defaultIlot}} pour tous les lots
                      </span>
                      <br>
                      <strong>Mode :</strong>
                      <span *ngIf="numberingMode === 'continue'">
                        <i class="fas fa-arrow-right text-info"></i> Continuer après les lots existants
                      </span>
                      <span *ngIf="numberingMode === 'restart'">
                        <i class="fas fa-redo text-warning"></i> Redémarrer depuis {{startNumber}}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-2 mt-2" *ngIf="edit">
            <div class="flex-grow-0" style="min-width: 30%">
              <app-image-uploader
                (filesd)="loadfile($event)"
                [maxSize]="2"
                [type]="['image/png', 'image/jpg', 'image/jpeg']"
                (imageUploaded)="setParam('photoUuid',$event)"
                [photo]="home ? home?.photo : null "></app-image-uploader>
            </div>
            <div class="col-md">
              <label>Pièces et documents à joindre</label>
              <app-folder-uploader
                [maxSize]="3"
                (filesd)="files($event)"
                (filesUploaded)="setParam('folderUuid',$event)"
                [type]="['image/png', 'image/jpg', 'image/jpeg']"
                [path]="'home'"
                [etat]="edit ? 'edit': 'add'"
                [folder]="edit && home ? home?.folder : null">
              </app-folder-uploader>
            </div>
          </div>

          <div class="col-md-12 text-center mt-2">
            <button type="button" awNextStep class="btn btn-primary" *ngIf="(f.promotion.value && f.nbrMaison.value > 0) || edit">
              Suivant <i class="feather icon-arrow-right"></i>
            </button>
          </div>
        </aw-wizard-step>

        <!-- STEP 2 DU FORMULAIRE -->
        <aw-wizard-step *ngIf="!edit" stepTitle="Maison">
          <div class="row">
            <span class="badge badge-secondary my-2 f-14 width">
              PARTIE RESERVÉE AUX MAISONS
            </span>
          </div>
          <div formArrayName="maisons">
            <div class="fom-group">
              <div class="row">
                <div class="col-md-2">
                  <label for="lot">N° Lot <span class="asterix">*</span></label>
                </div>
                <div class="col-md-2">
                  <label for="ilot">N° Ilot <span class="asterix">*</span></label>
                </div>
                <div class="col-md-2">
                  <label for="montant">Montant <span class="asterix">*</span></label>
                </div>
                <div class="col-md-2">
                  <label for="baseActualisation">Base actualisation <span class="asterix">*</span></label>
                </div>
                <div class="col-md-2">
                  <label for="superficie">Superficie <span class="asterix">*</span></label>
                </div>
              </div>
            </div>
            <div class="form-group" *ngFor="let item of maison.controls; let i=index" [formGroupName]="i">
              <div class="row">
                <div class="col-md-2">
                  <input type="text" formControlName="lot" class="form-control pl-2 font-weight-bold" id="lot{{i}}"
                    style="background-color: white;"
                    [ngClass]="{
                      'is-invalid': submit && item.get('lot').errors,
                      'is-valid': submit && item.get('lot').valid
                    }" placeholder="N° Lot">
                </div>
                <div class="col-md-2">
                  <input type="number" formControlName="ilot" class="form-control pl-2 font-weight-bold" id="ilot{{i}}"
                    style="background-color: white;"
                    [ngClass]="{
                      'is-invalid': submit && item.get('ilot').errors,
                      'is-valid': submit && item.get('ilot').valid
                    }" placeholder="N° Ilot">
                </div>
                <div class="col-md-2">
                  <input type="number" step="5000" formControlName="montant" class="form-control" id="montant{{i}}"
                    style="background-color: white;"
                    [ngClass]="{
                      'is-invalid': submit && item.get('montant').errors,
                      'is-valid': submit && item.get('montant').valid
                    }" placeholder="Montant">
                  <div class="invalid-feedback" *ngIf="submit && item.get('montant').errors">
                    <div *ngIf="item.get('montant').errors.required">{{required.novide}}</div>
                    <div *ngIf="item.get('montant').errors.pattern">{{required.nolettre}}</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" step="5000" formControlName="baseActualisation" class="form-control" id="baseActualisation{{i}}"
                    style="background-color: white;"
                    [ngClass]="{
                      'is-invalid': submit && item.get('baseActualisation').errors,
                      'is-valid': submit && item.get('baseActualisation').valid
                    }" placeholder="Base actualisation">
                  <div class="invalid-feedback" *ngIf="submit && item.get('baseActualisation').errors">
                    <div *ngIf="item.get('baseActualisation').errors.required">{{required.novide}}</div>
                    <div *ngIf="item.get('baseActualisation').errors.pattern">{{required.nolettre}}</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" step="5000" formControlName="superficie" class="form-control" id="superficie{{i}}"
                    style="background-color: white;"
                    [ngClass]="{
                      'is-invalid': submit && item.get('superficie').errors,
                      'is-valid': submit && item.get('superficie').valid
                    }" placeholder="Superficie">
                  <div class="invalid-feedback" *ngIf="submit && item.get('superficie').errors">
                    <div *ngIf="item.get('superficie').errors.required">{{required.novide}}</div>
                    <div *ngIf="item.get('superficie').errors.pattern">{{required.nolettre}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 centered-content mt-3">
            <div class="btn-group mt-10">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précedent
              </button>
              <button type="button" awNextStep class="btn btn-primary ml-1">
                Suivant <i class="feather icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </aw-wizard-step>

        <!-- STEP 3 DU FORMULAIRE -->
        <aw-wizard-step stepTitle="Offre">
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width"> Informations supplémentaires</span>
          </div>

          <div class="row m-2 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Les informations relatives aux pièces du bien</span>
            <form autocomplete="off" [formGroup]="pieceForm">
              <div class="form-group">
                <div class="row mb-2">
                  <div class="col-md-3">
                    <label for="chambre">Chambres </label>
                    <input type="number" min="0" class="form-control" formControlName="chambre" id="chambre">
                  </div>
                  <div class="col-md-3">
                    <label for="douche">Douches </label>
                    <input type="number" min="0" class="form-control" formControlName="douche" id="douche">
                  </div>
                  <div class="col-md-3">
                    <label for="salon">Salons </label>
                    <input type="number" min="0" class="form-control" formControlName="salon" id="salon">
                  </div>
                  <div class="col-md-3">
                    <label for="garage">Garages </label>
                    <input type="number" min="0" class="form-control" formControlName="garage" id="garage">
                  </div>
                  <div class="col-md-3">
                    <label for="cuisine">Cuisine </label>
                    <input type="number" min="0" class="form-control" formControlName="cuisine" id="cuisine">
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="row m-2 mb-2" >
            <span class="badge badge-secondary my-2 f-14 width"> Les informations relatives aux équipements du bien</span>
            <div class="col-md-12">
              <form autocomplete="off" [formGroup]="equipementForm">
                <div class="form-group">
                  <div class="row m-4">
                    <div class="col-md-4">
                      <p>
                        <input class="form-check-input" id="wifi" type="checkbox" formControlName="wifi">
                        <label for="wifi">WiFi </label>
                      </p>
                      <p>
                        <input class="form-check-input" id="piscine" type="checkbox" formControlName="piscine">
                        <label for="piscine">Piscine </label>
                      </p>
                      <p>
                        <input class="form-check-input" id="securite" type="checkbox" formControlName="securite">
                        <label for="securite">Gardien de Sécurité</label>
                      </p>
                    </div>
                    <div class="col-md-4">
                      <p>
                        <input class="form-check-input" id="clim" type="checkbox" formControlName="clim">
                        <label for="clim">Air Conditioner </label>
                      </p>
                      <p>
                        <input class="form-check-input" id="urgence" type="checkbox" formControlName="urgence">
                        <label for="urgence">Issue d'Urgence</label>
                      </p>
                      <p>
                        <input class="form-check-input" id="incendie" type="checkbox" formControlName="incendie">
                        <label for="incendie">Borne d'incendie </label>
                      </p>
                    </div>
                    <div class="col-md-4">
                      <p>
                        <input class="form-check-input" id="parking" type="checkbox" formControlName="parking">
                        <label for="parking">Parking </label>
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row m-4 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> La gallerie du bien</span>
            <div class="col-md-12">
              <app-folder-upload
                (filesUploaded)="uploadFile($event, 'GALLERY')"
                [maxSize]="3"
                [type]="['jpg', 'png', 'jpeg']"
                [etat]="'add'"
                [folder]="null" >
              </app-folder-upload>
            </div>
          </div>
          <div class="row m-2 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Video de présentation</span>
            <div class="col-md-12">
              <form autocomplete="off" [formGroup]="videoForm">
                <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                      <label for="link">Lien de la vidéo <span class="asterix">*</span></label>
                      <input type="text" class="form-control" formControlName="link" id="link">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row m-4 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Plan</span>
            <div class="col-md-12">
              <app-folder-upload-2
                (filesUploaded)="uploadFile($event, 'PLAN')"
                [maxSize]="3"
                [type]="['jpg', 'png', 'jpeg']"
                [etat]="'add'"
                [folder]="null" >
              </app-folder-upload-2>
            </div>
          </div>
          <div class="col-sm-12 centered-content mt-3">
            <div class="btn-group mt-10">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précedent
              </button>
            </div>
          </div>
        </aw-wizard-step>
      </aw-wizard>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="modal.close('ferme')" type="button" class="btn btn-secondary text-left" data-dismiss="modal">
      Fermer <i class="feather icon-x-circle"></i>
    </button>
    <button (click)="form.reset()" type="button" class="btn btn-warning">
      Vider <i class="fas fa-broom"></i>
    </button>
    <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
      Enregistrer <i class="feather icon-save"></i>
    </button>
  </div>
</form>